// Libs
import { RestLink } from 'apollo-link-rest';
import { getAppSetting } from '../../ApplicationSettings';
import { concat } from '@apollo/client';

// Authlink
import { authLink, linkError } from '../../../src/api/authLink';

// Helpers
import commonHeaders from '../commonHeaders';
import { APIDOMAIN, apiEndpoint } from '@ibinder/common-utils';

const configuredRestLink = () => {
  const apiEndpointFor = apiEndpoint(getAppSetting('REACT_APP_API_URL'));
  const {
    issues,
    inspections,
    binders,
    users,
    customers,
    admin,
    facilities,
    etendering,
    documents,
    activities
  } = APIDOMAIN;

  return new RestLink({
    endpoints: {
      binder: {
        uri: apiEndpointFor(binders)
      },
      issues: {
        uri: apiEndpointFor(issues)
      },
      inspections: {
        uri: apiEndpointFor(inspections)
      },
      organizations: {
        uri: apiEndpointFor(customers)
      },
      admin: {
        uri: apiEndpointFor(admin)
      },
      users: {
        uri: apiEndpointFor(users)
      },
      // templates: { //TODO: REMOVE
      //   uri: getAppSetting('REACT_APP_TEMPLATES_API')
      // },
      facilities: {
        uri: apiEndpointFor(facilities)
      },
      documents: {
        uri: apiEndpointFor(documents)
      },
      etendering: {
        uri: apiEndpointFor(etendering)
      },
      csvadmin: {
        uri: apiEndpointFor(users),
        responseTransformer: async (response) => {
          const res = await response.text();
          return res;
        }
      },
      users2fa: {
        uri: apiEndpointFor(users),
        responseTransformer: async (response) => {
          if (!response?.status || response.status === 204) return { level: null };
          const text = JSON.parse(await response.text());
          return { level: text || null };
        }
      },
      activities: {
        uri: apiEndpointFor(activities)
      }
    },

    // TODO: COMMENT
    // uri: getAppSetting('REACT_APP_ISSUES_API'),
    headers: {
      ...commonHeaders
    }
  });
};

export default linkError.concat(authLink()).concat(configuredRestLink());
